const styles = () => ({
  root: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 50px 0 0',
  },

  pane: {
    border: '1px solid #F0F3F6',
    borderRadius: 9,
    paddingTop: '25px',
    display: 'flex',
    flexDirection: 'column',
    flex: 'none',
    alignItems: 'center',
    overflow: 'auto',
    marginBottom: 50,
  },

  header: {
    display: 'flex',
    flex: 'none',
    padding: '34px 0px 10px 0',
  },

  link: {
    fontSize: '15px',
    color: '#5786D7',
    textDecoration: 'none',
  },

  refresh: {
    color: '#5786d7',
    cursor: 'pointer',
    fontWeight: 500,
    height: 36,
    padding: '6px 0',
  },

  icon: {
    marginLeft: '8px',
    height: '20px',
    verticalAlign: 'bottom',
  },

  spacer: {
    flex: '1 1 auto',
  },

  submission: {
    paddingTop: '0px 10px',
  },

  panePlaceholder: {
    backgroundColor: '#fcfcfc',
    border: '1px dashed #ddd',
  },

  previewPlaceholder: {
    textAlign: 'center',
    paddingTop: 150,
    paddingBottom: 150,
    color: 'lightgrey',
    width: '100%',
  },

  footer: {
    alignItems: 'center',
    borderTop: 'solid 1px #eff2f4',
    display: 'flex',
    fontWeight: 500,
    height: 60,
    justifyContent: 'space-around',
    width: '100%',
  },

  previewTab: {
    alignItems: 'center',
    borderRight: 'solid 1px #eff2f4',
    display: 'flex',
    height: '100%',
    justifyContent: 'space-around',
    width: '50%',
  },

  previewOverlay: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'space-around',
    width: '50%',
  },
});

export default styles;
